import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method requestOtp
 * @method confirmOtp
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * @param {String} contactNumber (required)
     * @param {String} uuid (optional)
     */
    requestOtp: function(contactNumber, uuid, channel) {

        if (!channel) {
            channel = "authen";
        }
        //  else {
        //     channel = "process";
        // }
        var params = {
            contact_number: contactNumber,
            app_id: this.config().client_id,
            uuid: uuid,
            channel: channel,
        };

        var url = this.config().bzbsServiceUrl + "/auth/otp";
        return BzbsApi.connectBzbsGet(url, null, params);
    },

    /**
     * @param {String} token
     * @param {String} contactNumber
     * @param {String} refcode
     * @param {String|Number} otp
     */
    confirmOtp: function(token, contactNumber, refcode, otp) {
        var params = {
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode,
            channel: "register"
        };

        // var url = this.config().bzbsServiceUrl + "/auth/bzbs_authen";
        var url = this.config().bzbsModuleUrl + "/main/validateotp";
        return BzbsApi.connectBzbsPost(url, token, params);
    },
}
